'use strict'

const form = {
    init: function() {
        if (document.querySelector('.js-btn-job-form')) {
            this.constructor();
            this.displayForm();
            this.handleFile();
            if (document.querySelector('.js-submit-job-form')) {
                this.sendForm();
            }
        }
    },
    constructor() {
        this.lastName = document.querySelector('#job_lname');
        this.firstName = document.querySelector('#job_fname');
        this.email = document.querySelector('#job_email');
        this.message = document.querySelector('#job_message');
        this.optin_rgpd = document.querySelector('#job-terms');
        this.cv = document.querySelector('#upload-cv');
    },
    displayForm: function() {
        const btnsOpen = document.querySelectorAll('.js-btn-job-form');
        const btnClose = document.querySelector('.js-close-job-form');
        const formContainer = document.querySelector('.job-form__wrapper');
        btnsOpen.forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelector('body').style.overflow = "hidden";
                formContainer.classList.add('open');
            })
        })
        btnClose.addEventListener('click', () => {
            formContainer.classList.remove('open');
            document.querySelector('body').style.overflow = "visible";
        })
    },
    sendForm: function() {
        const form = document.querySelector('.js-job-form');

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            var formdata = this.getAllDatas();
            var requestOptions = {
                method: 'POST',
                body: formdata
            };

            fetch(api.contact, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.code == "error_validation") {
                        this.errorForm(result);
                    } else {
                        this.successForm(result.data.msg);
                        form.reset();
                    }
                })
                .catch(error => console.log('error', error));
        })
    },
    getAllDatas: function() {
        let formdata = new FormData(document.querySelector('.js-job-form'));
        return formdata;
    },
    successForm(message) {
        document.querySelector('#successMessageJobForm').innerHTML = message;
        const errors = document.querySelectorAll('.errorMessage');

        for (let err of errors) {
            this.valid.inputText(err);
        }
    },
    errorForm: function(error) {
        const { data } = error;
        const { errors } = data;

        const {
            contact_last_name,
            contact_first_name,
            contact_email,
            contact_message,
            contact_cv,
            contact_optin_rgpd
        } = errors;

        contact_last_name ? this.errors.inputText(this.lastName, contact_last_name) : this.valid.inputText(this.lastName);
        contact_first_name ? this.errors.inputText(this.firstName, contact_first_name) : this.valid.inputText(this.firstName);
        contact_email ? this.errors.inputText(this.email, contact_email) : this.valid.inputText(this.email);
        contact_message ? this.errors.inputText(this.message, contact_message) : this.valid.inputText(this.message);
        contact_cv ? this.errors.inputText(this.cv, contact_cv) : this.valid.inputText(this.cv);
        contact_optin_rgpd ? this.errors.inputText(this.optin_rgpd, contact_optin_rgpd) : this.valid.inputText(this.optin_rgpd);
        grecaptcha.reset();
    },
    handleFile: function() {
        const uploadContent = document.querySelector('#upload-cv-file');
        const uploadContentFilename = uploadContent.querySelector('.filename');
        const uploadContentNoFile = uploadContent.querySelector('.no-file');
        const uploadContentTooLarge = uploadContent.querySelector('.too-large');
        const uploadFileInput = document.querySelector('#upload-cv');
        const uploadFileButton = document.querySelector('#upload-cv-button');
        const removeFileButton = uploadContent.getElementsByTagName('button')[0];

        uploadFileButton.onclick = () => {
            uploadFileInput.click();
        }

        this.cv.onchange = () => {
            const selectedFile = this.cv.files[0];
            if (selectedFile.size > 2000000) {
                removeFileButton.style.display = "none";
                uploadContentNoFile.style.display = "none";
                uploadContentTooLarge.style.display = "block";
                return;
            }

            uploadContentTooLarge.style.display = "none";
            uploadContentNoFile.style.display = "none";
            removeFileButton.style.display = "block";
            uploadContentFilename.innerText = selectedFile.name;
        }

        removeFileButton.onclick = () => {
            removeFileButton.style.display = "none";
            uploadContentNoFile.style.display = "block";
            uploadContentFilename.innerText = "";
            this.cv.value = "";
        }
    },


    errors: {
        inputText(element, message) {
            element.parentElement.querySelector('.errorMessage').innerHTML = message;
            element.parentElement.querySelector('.errorMessage').style.display = 'block';
        }
    },
    valid: {
        inputText(element) {
            element.parentElement.querySelector('.errorMessage').innerHTML = "";
            element.parentElement.querySelector('.errorMessage').style.display = 'none';
        }
    }

}


export default form;